export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учетные формы: Лист фонда",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
